module.exports = __webpack_public_path__ + "static/media/echo6.7384e936.jpg";